import { useEffect, useState } from 'react';
import type { Folder } from '../../../../util/Types/Folder';
import { mergeLocalFolderState } from './folderItemMerge';

export const useFolderLocalContent = (folder: Folder) => {
  const [localFolder, setLocalFolder] = useState(folder);
  useEffect(() => {
    setLocalFolder(prev => mergeLocalFolderState(prev, folder));
  }, [folder]);
  return [localFolder, setLocalFolder] as const;
};
